import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selector", "teamsField", "employeesField"]

  connect() {
    this.toggle()
  }

  toggle() {
    const value = this.selectorTarget.value

    this.teamsFieldTarget.classList.toggle("hidden", value !== "teams")
    this.employeesFieldTarget.classList.toggle("hidden", value !== "employees")
  }
}
